import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useTranslation } from "../i18n";
import "./Navbar.css";

export default function Navbar() {
  const { user, logout } = useAuth();
  const { t, locale, setLocale } = useTranslation();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <Link to="/" className="navbar-brand">
          <img src="/logos/logo-name-green.png" alt="ViewsDay" className="brand-logo" />
          <span className="brand-live">LIVE</span>
        </Link>

        <div className="navbar-links">
          <Link to="/pricing" className={`nav-link ${isActive("/pricing") ? "active" : ""}`}>
            {t("nav.pricing")}
          </Link>

          {user ? (
            <>
              <Link to="/dashboard" className={`nav-link ${isActive("/dashboard") ? "active" : ""}`}>
                {t("nav.dashboard")}
              </Link>
              {user.role === "admin" && (
                <>
                  <Link to="/admin" className={`nav-link ${isActive("/admin") ? "active" : ""}`}>
                    {t("nav.admin")}
                  </Link>
                  <Link to="/admin/whatsapp-messages" className={`nav-link ${isActive("/admin/whatsapp-messages") ? "active" : ""}`}>
                    {t("nav.messages")}
                  </Link>
                </>
              )}
              <div className="navbar-user">
                <span className="user-plan">{user.plan}</span>
                <span className="user-email">{user.email}</span>
                <button onClick={logout} className="btn-logout">{t("nav.signOut")}</button>
              </div>
            </>
          ) : (
            <Link to="/login" className="nav-link nav-cta">
              {t("nav.signIn")}
            </Link>
          )}

          <button
            className="lang-toggle"
            onClick={() => setLocale(locale === "en" ? "pt-BR" : "en")}
            title={locale === "en" ? "Mudar para Português" : "Switch to English"}
          >
            {locale === "en" ? "PT" : "EN"}
          </button>
        </div>
      </div>
    </nav>
  );
}
